import React from 'react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { personnel, pendingInvitations } from '../../data/sampleData';
import { UserPlusIcon, MoreHorizontalIcon, MailIcon, XIcon } from 'lucide-react';
export const TeamPage: React.FC = () => {
  return <div data-id="element-510">
      <div className="flex justify-between items-center mb-8" data-id="element-511">
        <h1 className="text-2xl font-bold text-gray-12" data-id="element-512">Team Management</h1>
        <Button icon={<UserPlusIcon size={16} data-id="element-514" />} data-id="element-513">Invite Member</Button>
      </div>
      <div className="space-y-4 mb-8" data-id="element-515">
        {personnel.map(person => <Card key={person.id} className="flex items-center justify-between p-5" data-id="element-516">
            <div className="flex items-center" data-id="element-517">
              <div className="h-12 w-12 bg-gray-4 rounded-full flex items-center justify-center mr-4" data-id="element-518">
                <span className="font-medium text-gray-11 text-lg" data-id="element-519">
                  {person.avatar}
                </span>
              </div>
              <div data-id="element-520">
                <div className="flex items-center" data-id="element-521">
                  <h3 className="text-base font-medium text-gray-12 mr-3" data-id="element-522">
                    {person.name}
                  </h3>
                  <Badge variant={person.role === 'Admin' ? 'indigo' : 'gray'} className="uppercase" data-id="element-523">
                    {person.role}
                  </Badge>
                </div>
                <p className="text-sm text-gray-11" data-id="element-524">{person.email}</p>
                <p className="text-xs text-gray-10 mt-1" data-id="element-525">
                  Joined {person.joinedDate}
                </p>
              </div>
            </div>
            <button className="text-gray-11 hover:text-gray-12 p-2" data-id="element-526">
              <MoreHorizontalIcon size={20} data-id="element-527" />
            </button>
          </Card>)}
      </div>
      {pendingInvitations.length > 0 && <div data-id="element-528">
          <h2 className="text-lg font-semibold text-gray-12 mb-4" data-id="element-529">
            Pending Invitations
          </h2>
          <div className="space-y-4" data-id="element-530">
            {pendingInvitations.map(invitation => <Card key={invitation.id} className="flex items-center justify-between p-5" data-id="element-531">
                <div className="flex items-center" data-id="element-532">
                  <div className="h-10 w-10 bg-yellow-3 rounded-full flex items-center justify-center mr-4" data-id="element-533">
                    <MailIcon size={18} className="text-yellow-11" data-id="element-534" />
                  </div>
                  <div data-id="element-535">
                    <p className="text-base font-medium text-gray-12 flex items-center" data-id="element-536">
                      {invitation.email}
                      <Badge variant="yellow" className="ml-3" data-id="element-537">
                        Pending
                      </Badge>
                    </p>
                    <div className="flex items-center text-sm text-gray-10 mt-1" data-id="element-538">
                      <span data-id="element-539">Invited {invitation.invitedDate}</span>
                      <span className="mx-2" data-id="element-540">•</span>
                      <button className="text-indigo-9 hover:text-indigo-10" data-id="element-541">
                        Resend invitation
                      </button>
                    </div>
                  </div>
                </div>
                <button className="text-gray-11 hover:text-red-9 p-2" data-id="element-542">
                  <XIcon size={20} data-id="element-543" />
                </button>
              </Card>)}
          </div>
        </div>}
    </div>;
};